var mq = function (breakpoint) { return function (theme) {
    return theme.breakpoints
        ? "@media (min-width: " + theme.breakpoints[breakpoint] + ")"
        : null;
}; };
export var media = {
    mobile: mq('mobile'),
    tablet: mq('tablet'),
    desktop: mq('desktop'),
    smallscreen: mq('smallscreen')
};
//# sourceMappingURL=responsive.js.map